export const REINVENT_EVENT_NAME = 'reInvent23';
export const SKILL_BUILDER_LINK = 'https://skillbuilder.aws/';
